import { useBranding } from '../store/branding';

interface BrandLogoProps {
  width?: number;
  className?: string;
}

export default function BrandLogo({ width = 320, className = '' }: BrandLogoProps) {
  const { productName } = useBranding();
  return (
    <div className={`flex flex-col items-center text-center ${className}`}>
      <img
        src={`${import.meta.env.BASE_URL}brand-logo.jpg`}
        alt={productName}
        width={width}
        style={{ height: 'auto' }}
        className="shrink-0"
      />
    </div>
  );
}
